﻿﻿﻿<div class="container-tab-lists">
    <controllertypetomasterdatarequired-menu (onRefresh)="refreshAll()"></controllertypetomasterdatarequired-menu>
    <div class="inner-tcontainer-tab">
        <div class="tab-body">
            <div class="tab-content">
                <controllertypetomasterdatarequired-list [list]="controllertypetomasterdatarequired" (onRefresh)="refreshAll()"></controllertypetomasterdatarequired-list>
            </div> <!--tab-content-->
        </div> <!--tab-body-->
    </div> <!--inner-tcontainer-tab-->
</div> <!--container-tab-lists-->